import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, ActivationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LayoutFooter, LayoutHeader } from './app-routing.enum';
// import {FirebaseService} from './services/firebase.service';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { LoaderService } from './services/loader.service';
import { UserService } from './services/user.service';
import { gtagTrigger } from 'analytics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public topbarHeight: number = 0;

  public readonly LAYOUT_HEADER = LayoutHeader;

  public readonly LAYOUT_FOOTER = LayoutFooter;

  public LayoutHeader?: LayoutHeader;

  public LayoutFooter?: LayoutFooter;

  public overflow: 'hidden' | null = null;

  constructor(
    // private firebaseService: FirebaseService,
    public router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private titleService: Title,
    private meta: Meta,
    private _loaderService: LoaderService,
    private _user: UserService,
    private _cdr: ChangeDetectorRef,
  ) {
    if (this.router.navigated) {
      this._setRouteData(this._getLastRouteState(this.route).snapshot);
    }

    this.router.events
      .pipe(
        filter((event): event is ActivationEnd => event instanceof ActivationEnd),
      )
      .subscribe(event => {
        this._setRouteData(event.snapshot);
        gtagTrigger('event', 'page_view');
      });

    this._user.init();
  }

  ngOnInit() {
    this._loaderService.shown$.subscribe(shown => {
      this.overflow = shown ? 'hidden' : null;
      this._cdr.detectChanges();
    });

    this.translateService.use(environment.defaultLocale);
  }

  private _setRouteData(snapshot: ActivatedRouteSnapshot) {
    this.titleService.setTitle(snapshot.data?.title);

    if (snapshot.data?.meta_title) {
      this.meta.updateTag({ name: 'title', content: snapshot.data?.meta_title });
    } else {
      const ogTagsManage = this.meta.getTag('name="title"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.description) {
      this.meta.updateTag({ name: 'description', content: snapshot.data?.description });
    } else {
      const ogTagsManage = this.meta.getTag('name="description"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.og_title) {
      this.meta.updateTag({ property: 'og:title', content: snapshot.data?.og_title });
    } else {
      const ogTagsManage = this.meta.getTag('property="og:title"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.og_description) {
      this.meta.updateTag({ property: 'og:description', content: snapshot.data?.og_description });
    } else {
      const ogTagsManage = this.meta.getTag('property="og:description"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.og_url) {
      this.meta.updateTag({ property: 'og:url', content: snapshot.data?.og_url });
    } else {
      const ogTagsManage = this.meta.getTag('property="og:url"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.og_image) {
      this.meta.updateTag({ property: 'og:image', content: snapshot.data?.og_image });
    } else {
      const ogTagsManage = this.meta.getTag('property="og:image"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.og_site_name) {
      this.meta.updateTag({ property: 'og:site_name', content: snapshot.data?.og_site_name });
    } else {
      const ogTagsManage = this.meta.getTag('property="og:site_name"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.fb_app_id) {
      this.meta.updateTag({ property: 'fb:app_id', content: snapshot.data?.fb_app_id });
    } else {
      const ogTagsManage = this.meta.getTag('property="fb:app_id"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.og_type) {
      this.meta.updateTag({ property: 'og:type', content: snapshot.data?.og_type });
    } else {
      const ogTagsManage = this.meta.getTag('property="og:type"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.twitter_card) {
      this.meta.updateTag({ name: 'twitter:card', content: snapshot.data?.twitter_card });
    } else {
      const ogTagsManage = this.meta.getTag('name="twitter:card"')
      this.meta.removeTagElement(ogTagsManage);
    }

    if (snapshot.data?.twitter_site) {
      this.meta.updateTag({ name: 'twitter:site', content: snapshot.data?.twitter_site });
    } else {
      const ogTagsManage = this.meta.getTag('name="twitter:site"')
      this.meta.removeTagElement(ogTagsManage);
    }

    this.LayoutHeader = snapshot.data?.LayoutHeader;
    this.LayoutFooter = snapshot.data?.LayoutFooter;
  }

  private _getLastRouteState(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.children.length !== 0) {
      return this._getLastRouteState(activatedRoute.children[0]);
    }

    return activatedRoute;
  }
}
